// import { replaceAsInlineStyles } from "./utils/css/replaceAsInlineStyles";
// import { findElementsThatExist } from './utils/css/findElementsThatExist';
// import { removeUnusedStyles } from './utils/css/removeUnusedStyles';
import { replaceRemoteCssWithStyleTags } from './utils/css/replaceRemoteCssWithStyleTags';
import { downloadPropertiesAsBase64 } from './utils/html/downloadPropertiesAsBase64';
import { replaceCssWithBase64 } from './utils/images/replaceCssWithBase64';
import { replaceSrcSetWithCurrentSrc } from './utils/images/replaceSrcSetWithCurrentSrc';
import { replaceWithBase64 } from './utils/images/replaceWithBase64';
import { removeAllJavascriptFiles } from './utils/javascript/removeAllJavascriptFiles';

export async function absoluteDom(
  inputNode = document.documentElement,
  outputNode = document.documentElement
) {
  const script = document.createElement('script');
  script.textContent = 'window.proxyFetch = fetch';
  document.body.appendChild(script);

  const log = false;
  window.bugherdErrorLogging = log;

  const inputSize = inputNode.outerHTML.length / 1024 / 1024;
  if (log) console.log(`Size of inputNode: ${inputSize.toFixed(5)} MB`);

  const inputHtml = inputNode.outerHTML;
  outputNode.innerHTML = inputHtml;

  // findElementsThatExist(outputNode);

  try {
    if (log) console.log('Removing all javascript files START');
    await removeAllJavascriptFiles(outputNode);
    if (log) console.log('Removing all javascript files DONE');
  } catch (error) {
    if (log) console.error('Error removing all javascript files', error);
  }

  try {
    if (log) console.log('Replacing srcset with currentSrc START');
    await replaceSrcSetWithCurrentSrc(
      inputNode.querySelectorAll('img'),
      outputNode
    );
    if (log) console.log('Replacing srcset with currentSrc DONE');
  } catch (error) {
    if (log) console.error('Error replacing srcset with currentSrc', error);
  }

  try {
    if (log) console.log('Replacing images with base64 START');
    await replaceWithBase64(outputNode.querySelectorAll('img'));
    if (log) console.log('Replacing images with base64 DONE');
  } catch (error) {
    if (log) console.error('Error replacing images with base64', error);
  }

  try {
    if (log) console.log('Replacing remote css with style tags START');
    await replaceRemoteCssWithStyleTags(outputNode);
    if (log) console.log('Replacing remote css with style tags DONE');
  } catch (error) {
    if (log) console.error('Error remote css with style tags', error);
  }

  // this still doesn't work 100% because of media queries, bad parsing etc
  // TODO: fix this if it gets past POC

  // try {
  //   console.log('Removing unused styles START');
  //   await removeUnusedStyles(outputNode);
  //   console.log('Removing unused styles DONE');
  // } catch (error) {
  //   console.error('Error removing unused styles', error);
  // }

  try {
    if (log) console.log('Replacing css images with base64 START');
    await replaceCssWithBase64(outputNode);
    if (log) console.log('Replacing css images with base64 DONE');
  } catch (error) {
    if (log) console.error('Error replacing css images with base64', error);
  }

  try {
    if (log) console.log('Downloading properties as base64 START');
    await downloadPropertiesAsBase64(outputNode);
    if (log) console.log('Downloading properties as base64 DONE');
  } catch (error) {
    if (log) console.error('Error downloading properties as base64', error);
  }

  const outputSize = outputNode.outerHTML.length / 1024 / 1024;
  if (log) console.log(`Size of outputNode: ${outputSize.toFixed(5)} MB`);
}
